import React from "react";
import CompleteForm from "../CompleteForm";

const LoginPage = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const redirectUrl = queryParams.get("redirect") || "/";
  const failCode = queryParams.get("fail") || undefined;

  return (
    <CompleteForm
      name="Login"
      requestPath="/login/user-login"
      showPasswordField={true}
      showEmail={true}
      failCode={failCode}
      showSubmitButton={true}
      submitButton="Login"
      afterLoginRedirect={redirectUrl}
      goToButton={{
        name: "Passwort vergessen?",
        to: "/forgotten-password",
      }}
    />
  );
};

export default LoginPage;
